export default __webpack_public_path__ + "static/media/torbjorn.de0529e7.webp";